import { format } from "date-fns";
import { DurationType } from "../models/Project";

/**
 * Format a currency amount in EUR using French locale
 */
export const formatCurrency = (amount?: number, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2): string => {
	if (!amount) return "-";
	return new Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits,
		maximumFractionDigits
	}).format(amount);
};

/**
 * Format a date string to dd/MM/yyyy format
 */
export const formatDate = (dateString?: string): string => {
	if (!dateString) return "-";
	return format(new Date(dateString), "dd/MM/yyyy");
};

/**
 * Calculate total working days for a project based on duration and type
 */
export const calculateWorkingDays = (
	duration?: number,
	durationType?: DurationType,
	fullTime?: boolean,
	daysPerPeriod?: number
): number => {
	if (!duration || !durationType) return 0;

	let totalDays = 0;
	const isPartTime = fullTime === false;
	const daysPerPeriodValue = daysPerPeriod ?? 0;

	if (durationType === DurationType.Weeks) {
		if (isPartTime && daysPerPeriodValue > 0) {
			totalDays = daysPerPeriodValue * duration;
		} else {
			totalDays = 5 * duration; // 5 days per week
		}
	} else if (durationType === DurationType.Months) {
		if (isPartTime && daysPerPeriodValue > 0) {
			totalDays = daysPerPeriodValue * duration;
		} else {
			totalDays = 20 * duration; // ~20 working days per month
		}
	}

	return totalDays > 0 ? totalDays : 0;
};